import { nonEmptyString, } from '../../validator.js';
import { validate, } from '../../validator.node.js';
const clientInvoiceDownloadTanRequestSchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        token: nonEmptyString(),
    },
    required: [
        'token',
    ],
};
export function clientInvoiceDownloadTanRequestValidate(props) {
    return validate(clientInvoiceDownloadTanRequestSchema, props);
}
const clientInvoiceDownloadTanResponseSchema = {
    oneOf: [
        {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    const: 'ok',
                },
                phone: nonEmptyString(),
            },
            required: [
                'status',
                'phone',
            ],
        },
        {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    const: 'error',
                },
                reason: {
                    type: 'string',
                    enum: [
                        'invalid token',
                        'country code missing',
                        'invalid phone number',
                        'too many tans requested',
                        'rate limited',
                    ],
                },
            },
            required: [
                'status',
                'reason',
            ],
        },
    ],
};
export function clientInvoiceDownloadTanResponseValidate(props) {
    return validate(clientInvoiceDownloadTanResponseSchema, props);
}
export async function clientInvoiceDownloadRequestTan(baseUrl, props) {
    const result = await fetch(`${baseUrl}/api/client/invoice/download/request-tan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    if (result.status === 200) {
        return await result.json();
    }
    if (result.status === 400) {
        // TODO: validate
        return await result.json();
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
const clientInvoiceDownloadInvoiceRequestSchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        token: nonEmptyString(),
        tan: nonEmptyString(),
    },
    required: [
        'token',
        'tan',
    ],
};
export function clientInvoiceDownloadInvoiceRequestValidate(props) {
    return validate(clientInvoiceDownloadInvoiceRequestSchema, props);
}
const clientInvoiceDownloadInvoiceResponseSchema = {
    oneOf: [
        {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    const: 'ok',
                },
            },
            required: [
                'status',
            ],
        },
        {
            type: 'object',
            additionalProperties: false,
            properties: {
                status: {
                    const: 'error',
                },
                reason: {
                    type: 'string',
                    enum: [
                        'invalid credentials',
                    ],
                },
            },
            required: [
                'status',
                'reason',
            ],
        },
    ],
};
export function clientInvoiceDownloadInvoiceResponseValidate(props) {
    // in case of download, there is nothing to validate
    if (props === undefined) {
        return [true, props];
    }
    return validate(clientInvoiceDownloadInvoiceResponseSchema, props);
}
export async function clientInvoiceDownloadInvoice(baseUrl, { action, ...props }) {
    const query = action ? `?action=${action}` : '';
    const response = await fetch(`${baseUrl}/api/client/invoice/download/invoice${query}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    const contentType = response.headers.get('Content-Type');
    if (contentType?.includes('application/json')) {
        if (response.status === 200) {
            return await response.json();
        }
        if (response.status === 400) {
            // TODO: validate
            return await response.json();
        }
        return {
            status: 'network error',
            httpStatus: response.status,
            message: await response.text(),
        };
    }
    const contentDisposition = response.headers.get('Content-Disposition');
    const fileName = contentDisposition?.match(/filename="?(.+?)"?$/)?.[1] ?? 'Rechnung.pdf';
    return {
        status: 'file',
        file: await response.blob(),
        fileName,
    };
}
//# sourceMappingURL=ClientInvoiceApi.js.map